import React from 'react';

import { useConfirmacao } from 'Component/Alerta';
import Icone from 'Component/Icone';

interface Props {
  icone?: string;
  children?: string | React.ReactElement | React.ReactElement[];
  className?: string;
  iconeClassName?: string;
  confirmacao?: string;
  onClick?: () => void;
  tema?:
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'light'
    | 'dark'
    | 'darkless'
    | 'primary'
    | 'secondary'
    | 'transparent'
    | 'outline-success'
    | 'outline-warning'
    | 'outline-danger'
    | 'outline-info'
    | 'outline-light'
    | 'outline-dark'
    | 'outline-darkless'
    | 'outline-primary'
    | 'outline-secondary';
  type?: 'button' | 'submit' | 'reset';
  circulo?: boolean;
  sm?: boolean;
  lg?: boolean;
  ms?: boolean;
  me?: boolean;
  processando?: boolean;
  texto?: string;
  textoEmProcessamento?: string;
}

const Botao = (props: Props): React.ReactElement => {
  const modal = useConfirmacao();
  const {
    icone,
    children,
    className,
    iconeClassName,
    confirmacao,
    onClick,
    tema = 'primary',
    type = 'button',
    circulo,
    sm,
    lg,
    ms,
    me,
    processando = false,
    texto,
    textoEmProcessamento = 'Aguarde...',
  } = props;

  return (
    <button
      type={type}
      className={[
        `btn btn-${tema}`,
        'text-nowrap',
        sm && 'btn-sm',
        lg && 'btn-lg',
        ms && 'ms-2',
        me && 'me-2',
        circulo && 'rounded-circle',
        className,
      ].paraClassName()}
      {...(onClick
        ? {
            onClick: () =>
              typeof confirmacao === 'string'
                ? modal({ conteudo: confirmacao, aoConfirmar: onClick })
                : onClick(),
          }
        : {})}
      {...(processando ? { disabled: true } : {})}
    >
      {!processando ? (
        <React.Fragment>
          {icone && (
            <Icone
              nome={icone}
              {...(texto || children ? { className: 'me-2 ' + iconeClassName } : {})}
            />
          )}
          {texto || children}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="spinner-grow spinner-grow-sm" role="status">
            <span className="visually-hidden">{textoEmProcessamento}</span>
          </div>
          {texto || children ? <span className="ms-2">{textoEmProcessamento}</span> : ''}
        </React.Fragment>
      )}
    </button>
  );
};

export default Botao;
